export const endPoints = {
  PAYMENT_FILTER_EXCEL: '/v1/contract/payment/filter/excel',
  PAYMENT_FILTER: '/v1/contract/payment/filter',
  PAYMENT_FILTER_SUM: '/v1/contract/payment/filter/sum',
  CONTRACT: '/v1/contract/'
};
